import {styled} from "@mui/material/styles"

const NoBorderButton = styled("button")`
    cursor: pointer;
    border: none;
    padding: 0;
    background: transparent;
    -webkit-tap-highlight-color: transparent;
`

export const FiltersMenuButton = styled(NoBorderButton)`
    width: 100%;
    height: 3.5rem;
    color: ${({theme}) => theme.colours.palette.text.primary};
    font-size: ${({theme}) => theme.colours.typography.body3.fontSize};
    font-family: ${({theme}) => `${theme.colours.component.buttonLarge.fontFamily}, ${theme.colours.font.default}`};
    font-weight: ${({theme}) => theme.colours.component.buttonLarge.fontWeight};
    letter-spacing: ${({theme}) => theme.colours.component.buttonLarge.letterSpacing};
    line-height: ${({theme}) => theme.colours.component.buttonLarge.lineHeight};
    text-transform: ${({theme}) => theme.colours.typography.overline.textTransform};
    display: flex;
    align-items: center;
    justify-content: center;
    .plp-filters-menu-text {
        letter-spacing: 0.0625rem;
    }
`

export const FiltersMenuButtonText = styled("div")`
    font-weight: ${({theme}) => theme.colours.typography.body3.fontWeight};
`

export const FilterIcon = styled("img")`
    color: ${({theme}) => theme.colours.text.default};
    height: 1.5rem;
    margin-right: 0.5rem;
`
